import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import Tooltip from 'components/generic/Tooltip.component';
import { useAppointmentPermissions } from 'hooks/useAppointmentPermissions.hook';
import { selectSchedulerAllowCreation } from 'selectors/scheduler.selectors';
import { formatYearToDayCompact } from 'utils/date/format.util';

import CN from './SchedulerHeader.module.scss';

const SchedulerHeaderGatedAddAppointmentItem = ({ t, isMobile, salonId, selectedDate, createIfAllowed, setBookedByButton, trackEvent, onRequestClose, searchIsOpen }) => {
  const { isCreateBlocked } = useAppointmentPermissions();
  const allowCreation = useSelector(selectSchedulerAllowCreation);

  const onClick = useCallback(() => {
    if (!allowCreation || searchIsOpen) return;
    onRequestClose();
    trackEvent('add_booking_button');
    createIfAllowed(0, selectedDate, `/salon/${salonId}/day/${formatYearToDayCompact(selectedDate)}/appointment/new`);
    setBookedByButton(true);
  }, [allowCreation, searchIsOpen, createIfAllowed, onRequestClose, salonId, selectedDate, setBookedByButton, trackEvent]);

  const content = (
    <>
      <div
        className={cn({
          [CN.mobileCircleContainer]: isMobile,
        })}
      >
        <Icon variant="calendarDays" width="lg" unselected />
      </div>

      <span className={CN.dropdownText}>{t('scheduler.appointment')}</span>
      <ResponsiveBox.Mobile>
        <div className={CN.mobileArrow}>
          <Icon variant="arrowLeft" width="md" />
        </div>
      </ResponsiveBox.Mobile>
    </>
  );

  if (isCreateBlocked) {
    return (
      <Tooltip content={t('scheduler.appointmentPermissions.createNoAccessTooltip')} position="top" width="md">
        <div>
          <Button
            tag="SchedulerHeader__item-appointment"
            variant={isMobile ? 'mobilePanelItem' : 'dropdownItem'}
            height={isMobile ? 'lg2' : 'max'}
            type="button"
            disabled
            onClick={(e) => e.preventDefault()}
          >
            {content}
          </Button>
        </div>
      </Tooltip>
    );
  }

  return (
    <Button tag="SchedulerHeader__item-appointment" variant={isMobile ? 'mobilePanelItem' : 'dropdownItem'} height={isMobile ? 'lg2' : 'max'} onClick={onClick}>
      {content}
    </Button>
  );
};

export default SchedulerHeaderGatedAddAppointmentItem;
